/* Korean Member account surface. Ghost owns identity and deletion. */
(function () {
  const mount = document.querySelector('[data-member-account]');
  if (!mount) return;

  const element = (tag, text, className) => {
    const node = document.createElement(tag);
    if (text) node.textContent = text;
    if (className) node.className = className;
    return node;
  };

  const showSignedOut = () => {
    const link = element('a', '로그인');
    link.href = '/signin/';
    mount.replaceChildren(element('p', '계정관리를 보려면 로그인해 주세요.', 'billing-info'), link);
  };

  const showError = () => {
    mount.replaceChildren(element('p', '계정 정보를 확인할 수 없습니다. 잠시 후 다시 시도해 주세요.', 'billing-info billing-error'));
  };

  const showComplete = () => {
    mount.replaceChildren(
      element('p', '서비스 탈퇴가 완료되었습니다.', 'billing-info'),
      element('p', '현재 로그아웃 상태입니다. 다시 이용하려면 새로 가입해 주세요.')
    );
  };

  const renderAccount = (account) => {
    const details = document.createElement('dl');
    details.className = 'member-account-details';
    details.append(
      element('dt', '이메일'),
      element('dd', account.email),
      element('dt', '회원 상태'),
      element('dd', account.memberType === 'free' ? '무료 회원' : '유료 또는 혜택이 연결된 회원')
    );
    mount.replaceChildren(details);

    if (!account.withdrawalEligible) {
      mount.append(element('p', '현재 계정은 온라인에서 바로 탈퇴할 수 없습니다. 도움이 필요하면 고객센터에 문의해 주세요.', 'billing-info'));
      return;
    }

    const start = element('button', '서비스 탈퇴', 'billing-action billing-action-danger member-withdrawal-start');
    start.type = 'button';
    const confirmation = document.createElement('section');
    confirmation.className = 'member-withdrawal-confirmation billing-info';
    confirmation.hidden = true;
    confirmation.setAttribute('aria-labelledby', 'member-withdrawal-title');
    const title = element('h2', '서비스 탈퇴 확인');
    title.id = 'member-withdrawal-title';
    confirmation.append(title, element('p', '서비스 계정이 삭제됩니다. 다시 이용하려면 새로 가입해야 합니다.'));
    const cancel = element('button', '취소', 'billing-action billing-action-secondary');
    cancel.type = 'button';
    const confirm = element('button', '탈퇴 확정', 'billing-action billing-action-danger');
    confirm.type = 'button';
    const feedback = element('p', '', 'member-withdrawal-feedback');
    feedback.setAttribute('role', 'alert');
    confirmation.append(cancel, confirm, feedback);
    mount.append(start, confirmation);

    start.addEventListener('click', () => {
      confirmation.hidden = false;
      start.hidden = true;
      confirm.focus();
    });
    cancel.addEventListener('click', () => {
      confirmation.hidden = true;
      start.hidden = false;
      start.focus();
    });
    confirm.addEventListener('click', async () => {
      confirm.disabled = true;
      cancel.disabled = true;
      feedback.textContent = '';
      try {
        const response = await fetch('/billing/api/member-account/withdraw', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({confirmation: 'DELETE_MY_ACCOUNT'})
        });
        if (!response.ok) throw new Error('withdrawal_unavailable');
        const result = await response.json();
        if (result.status !== 'deleted') throw new Error('withdrawal_unconfirmed');
        location.replace('/account/?withdrawal=complete');
      } catch (_) {
        feedback.textContent = '탈퇴를 완료하지 못했습니다. 계정 상태를 다시 확인하거나 고객센터에 문의해 주세요.';
        confirm.disabled = false;
        cancel.disabled = false;
      }
    });
  };

  if (new URLSearchParams(location.search).get('withdrawal') === 'complete') {
    showComplete();
    return;
  }

  fetch('/billing/api/member-account/withdrawal', {credentials: 'same-origin', headers: {'Accept': 'application/json'}})
    .then((response) => {
      if (response.status === 401) return {unauthenticated: true};
      if (!response.ok) throw new Error('account_unavailable');
      return response.json();
    })
    .then((account) => {
      if (account.unauthenticated) showSignedOut();
      else renderAccount(account);
    })
    .catch(showError);
})();
